import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-header-list",
  "use": "icon-header-list-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-header-list\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path d=\"M48 304h928a48 48 0 1 0 0-96H48a48 48 0 1 0 0 96z m928 160H48a48 48 0 1 0 0 96h928a48 48 0 1 0 0-96z m0 256H48a48 48 0 1 0 0 96h928a48 48 0 1 0 0-96z\" fill=\"\" p-id=\"1930\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol